import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import operatorLogout from "~/operatorApplication/ts/service/status/OperatorLogout";
import {OPERATOR_APPLICATION_RELOAD_DATA_EVENT} from "~/operatorApplication/ts/service/comet/Constants";
import {
    OPERATOR_APPLICATION_MENU_ITEM_BUDDY_LIST_KEY,
    OperatorApplicationMenuItem,
    OperatorApplicationMenuSection
} from "~/operatorApplication/vue/layout/Interface";
import OperatorApplicationDialogs from "~/operatorApplication/vue/dialogs/OperatorApplicationDialogs.vue";
import {
    OPERATOR_APPLICATION_CONFIG_ROUTE_NAME,
    OPERATOR_APPLICATION_INITIATE_CHAT_ROUTE_NAME,
    OPERATOR_APPLICATION_NEWS_ROUTE_NAME
} from "~/operatorApplication/ts/router/OperatorApplicationRouteNames";
import OperatorApplicationConfig from "~/operatorApplication/vue/config/OperatorApplicationConfig.vue";
import OperatorApplicationNews from "~/operatorApplication/vue/news/OperatorApplicationNews.vue";
import {OperatorApplicationRoutingStore} from "~/operatorApplication/ts/store/OperatorApplicationRoutingStore";
import {OperatorApplicationEventManager} from "~/operatorApplication/ts/OperatorApplicationEventManager";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";
import {__} from "~/ts/library/Translate";
import Delay from "~/ts/library/Delay";
import OperatorApplicationPlatformFactory from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import OperatorApplicationInitiateChat
    from "~/operatorApplication/vue/initiateChat/OperatorApplicationInitiateChat.vue";
import OperatorApplicationMessageTemplates
    from "~/operatorApplication/ts/service/dialog/OperatorApplicationMessageTemplates";
import OpenApiResult from "~/ts/library/openApi/OpenApiResult";

export default class OperatorParamsLoader {

    static async reload(force: boolean = false, reason: string = null): Promise<boolean> {

        let success = false;
        if (OperatorAccountStore.isCabinetIframe) {
            if (OperatorAccountStore.data.value) {
                return true;
            }
        }

        if (OperatorAccountStore.isAuthorized.value) {
            if (!OperatorAccountStore.isOperatorParamsLoading.value || force) {
                console.info("Перезагрузка параметров", reason);
                OperatorAccountStore.setOperatorParamsLoading(true);
                try {
                    let p: OperatorApplicationApi.OperatorGetParamsOpenApiModel = {
                        getSearchFilters: false,
                        getMessageTemplates: false,
                        cabinetReportUsername: OperatorAccountStore.cabinetClientDialog.value?.username
                    };
                    if (reason) {
                        p.reason = reason;
                    }
                    let result = await (new OperatorApiRequest<OperatorApplicationApi.OperatorGetParamsResultOpenApiModel>({
                        url: "/operator/getParams",
                        p,
                        silentError: true,
                        silent: !!OperatorAccountStore.data.value
                    })).send();
                    if (result.isSuccess) {
                        OperatorApplicationPlatformFactory.window.setIcon("build/assets/operatorApplication/images/brands/online-chat/icon.png");
                        let data = result.data;
                        OperatorAccountStore.setData(data.params);
                        this.setApplicationMenu();

                        let buddyListSyncP: OperatorApplicationApi.OperatorSyncBuddyListOpenApiModel = {
                            knownUsernames: OperatorAccountStore.buddyList.value
                        };

                        if (!OperatorAccountStore.isCabinetIframe) {
                            let buddyListSyncResult = await (new OperatorApiRequest<OperatorApplicationApi.OperatorSyncBuddyListResultOpenApiModel>({
                                url: "/buddyList/syncBuddyList",
                                silentError: true,
                                silent: true,
                                p: buddyListSyncP
                            })).send();
                            if (buddyListSyncResult.isSuccess) {
                                let data = buddyListSyncResult.data;
                                for (let username of data.add) {
                                    OperatorAccountStore.TOGGLE_CLIENT_IN_BUDDY_LIST({username, value: true});
                                }
                                for (let username of data.remove) {
                                    OperatorAccountStore.TOGGLE_CLIENT_IN_BUDDY_LIST({username, value: false});
                                }
                                success = true;
                                OperatorApplicationMessageTemplates.fetchFromServer();
                            }
                        } else {
                            success = true;
                        }
                    }
                } catch (e) {
                    console.error(e);
                    OperatorAccountStore.setOperatorParamsLoading(false);
                    if (OperatorAccountStore.data.value) {
                        await Delay.make(1000);
                        return await this.reload(force, reason);
                    }

                }
                OperatorAccountStore.setOperatorParamsLoading(false);
                if (!success) {
                    if (OperatorAccountStore.isCabinetIframe) {
                        OpenApiResult.showError("Не удалось загрузить информацию. Попробуйте обновить страницу.");
                        return false;
                    }
                    operatorLogout("Не удалось обновить информацию");
                    OperatorApplicationPlatformFactory.window.focus();
                }
            } else {
                success = true;
            }
        }
        return success;
    }


    private static setApplicationMenu() {
        let result: OperatorApplicationMenuSection[] = [];
        let mainBuddyListItems: OperatorApplicationMenuSection = {
            sortable: false,
            items: []
        };
        let customBuddyListItems: OperatorApplicationMenuSection = {
            sortable: true,
            items: []
        };
        let otherListItems: OperatorApplicationMenuSection = {
            sortable: false,
            items: []
        };
        result.push(mainBuddyListItems);

        for (let buddyList of OperatorAccountStore.data.value.buddyListConfig) {
            let sectionId = OperatorApplicationRoutingStore.getDialogsSectionId(buddyList.id);
            if (!OperatorApplicationRoutingStore.sectionId.value) {
                OperatorApplicationRoutingStore.setSectionId(sectionId);
            }
            let item: OperatorApplicationMenuItem = {
                sectionId: sectionId,
                component: OperatorApplicationDialogs,
                props: {
                    [OPERATOR_APPLICATION_MENU_ITEM_BUDDY_LIST_KEY]: buddyList
                },
                descr: buddyList.descr,
                icon: buddyList.icon,
                badgeValueGetter: () => {
                    return ClientUserdataStore.getUnreadedCountByBuddyList(buddyList.id);
                },
            };
            if (buddyList.isSystem) {
                mainBuddyListItems.items.push(item);
            } else {
                customBuddyListItems.items.push(item);
            }
        }
        if (customBuddyListItems.items.length) {
            result.push(customBuddyListItems);
        }
        result.push(otherListItems);

        if (OperatorAccountStore.data.value.accessRights.canStartChat) {
            otherListItems.items.push({
                sectionId: OPERATOR_APPLICATION_INITIATE_CHAT_ROUTE_NAME,
                component: OperatorApplicationInitiateChat,
                descr: __("Начать чат"),
                icon: "comment-plus"
            });
        }

        otherListItems.items.push({
            sectionId: OPERATOR_APPLICATION_CONFIG_ROUTE_NAME,
            component: OperatorApplicationConfig,
            descr: __("Настройки"),
            icon: "cog"
        });

        if (OperatorAccountStore.data.value.accessRights.canViewNews) {
            otherListItems.items.push({
                sectionId: OPERATOR_APPLICATION_NEWS_ROUTE_NAME,
                component: OperatorApplicationNews,
                descr: __("Новости"),
                icon: "newspaper",
                badgeValueGetter: () => {
                    return OperatorAccountStore.unreadedNewsCount.value;
                },
            });
        }
        OperatorApplicationRoutingStore.setMenu(result);
    }
}

OperatorApplicationEventManager.addEventListener(OPERATOR_APPLICATION_RELOAD_DATA_EVENT, async (reason?: string) => {
    try {
        await Delay.make(1000, `${OPERATOR_APPLICATION_RELOAD_DATA_EVENT}_delay`, true);
        OperatorParamsLoader.reload(null, reason);
    } catch (e) {

    }
});